import React from 'react'

declare module '@mui/material/styles' {
  interface TypographyVariants {
    subtitleLargeMedium: React.CSSProperties
    Body10pxHeavy: React.CSSProperties
    Body12pxRegular: React.CSSProperties
    Body12pxMedium: React.CSSProperties
    Body12pxHeavy: React.CSSProperties
    Body14pxMedium: React.CSSProperties
    Body14pxRegular: React.CSSProperties
    Body16pxRegular: React.CSSProperties
    Body16pxMedium: React.CSSProperties
    Body18pxMedium: React.CSSProperties
    H6Medium: React.CSSProperties
    H6Regular: React.CSSProperties
    H6Semibold: React.CSSProperties
    H5Semibold: React.CSSProperties
    H5Medium: React.CSSProperties
    H5Regular: React.CSSProperties
    HeaderSubtitleXSmallRegular: React.CSSProperties
    HeaderSubtitleSmallRegular: React.CSSProperties
    HeaderSubtitleSmallMedium: React.CSSProperties
    HeaderSubtitleSmallSemibold: React.CSSProperties
    HeaderSubtitleMediumMedium: React.CSSProperties
    HeaderSubtitleMediumRegular: React.CSSProperties
    HeaderSubtitleMediumLight: React.CSSProperties
    HeaderSubtitleMediumBold: React.CSSProperties
    HeaderSubtitleMediumSemibold: React.CSSProperties
    HeaderSubtitleLargeRegular: React.CSSProperties
    HeaderSubtitleLargeMedium: React.CSSProperties
    HeaderSubtitleLargeSemibold: React.CSSProperties
    HelperText: React.CSSProperties
    Tooltip: React.CSSProperties
    Tagline: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    subtitleLargeMedium?: React.CSSProperties
    Body10pxHeavy?: React.CSSProperties
    Body12pxRegular?: React.CSSProperties
    Body12pxMedium?: React.CSSProperties
    Body12pxHeavy?: React.CSSProperties
    Body14pxMedium?: React.CSSProperties
    Body14pxRegular?: React.CSSProperties
    Body14pxHeavy?: React.CSSProperties
    Body16pxRegular?: React.CSSProperties
    Body16pxMedium?: React.CSSProperties
    Body16pxHeavy?: React.CSSProperties
    Body18pxRegular?: React.CSSProperties
    Body18pxMedium?: React.CSSProperties
    H6Medium?: React.CSSProperties
    H6Regular?: React.CSSProperties
    H6Semibold?: React.CSSProperties
    H5Semibold?: React.CSSProperties
    H4Semibold?: React.CSSProperties
    H5Medium?: React.CSSProperties
    H5Regular?: React.CSSProperties
    HeaderSubtitleXSmallRegular?: React.CSSProperties
    HeaderSubtitleSmallRegular?: React.CSSProperties
    HeaderSubtitleSmallMedium?: React.CSSProperties
    HeaderSubtitleSmallSemibold?: React.CSSProperties
    HeaderSubtitleMediumRegular?: React.CSSProperties
    HeaderSubtitleMediumLight?: React.CSSProperties
    HeaderSubtitleMediumMedium?: React.CSSProperties
    HeaderSubtitleMediumBold?: React.CSSProperties
    HeaderSubtitleMediumSemibold?: React.CSSProperties
    HeaderSubtitleLargeRegular?: React.CSSProperties
    HeaderSubtitleLargeMedium?: React.CSSProperties
    HeaderSubtitleLargeSemibold?: React.CSSProperties
    HelperText?: React.CSSProperties
    Tooltip?: React.CSSProperties
    Tagline?: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subtitleLargeMedium: true
    Body10pxHeavy: true
    Body12pxRegular: true
    Body12pxMedium: true
    Body12pxHeavy: true
    Body14pxRegular: true
    Body14pxMedium: true
    Body14pxHeavy: true
    Body16pxRegular: true
    Body16pxMedium: true
    Body16pxHeavy: true
    Body18pxRegular: true
    Body18pxMedium: true
    H6Medium: true
    H6Regular: true
    H6Semibold: true
    H5Semibold: true
    H4Semibold: true
    H5Medium: true
    H5Regular: true
    HeaderSubtitleXSmallRegular: true
    HeaderSubtitleSmallRegular: true
    HeaderSubtitleSmallMedium: true
    HeaderSubtitleSmallSemibold: true
    HeaderSubtitleMediumMedium: true
    HeaderSubtitleMediumRegular: true
    HeaderSubtitleMediumLight: true
    HeaderSubtitleMediumBold: true
    HeaderSubtitleMediumSemibold: true
    HeaderSubtitleLargeRegular: true
    HeaderSubtitleLargeMedium: true
    HeaderSubtitleLargeSemibold: true
    HelperText: true
    Tooltip: true
    Tagline: true
  }
}

export const DEFAULT_FONT_FAMILY = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',')

export const typography = {
  h1: {
    fontSize: 32,
  },
  h2: {
    fontSize: 32,
  },
  h3: {
    fontSize: 22,
  },
  h4: {
    fontSize: 18,
  },
  h5: {
    fontSize: 16,
  },
  h6: {
    fontSize: 14,
  },
  subtitle1: {
    fontSize: 16,
  },
  subtitle2: {
    fontSize: 14,
  },
  body1: {
    fontSize: 14,
  },
  body2: {
    fontSize: 14,
  },
  subtitleLargeMedium: {
    fontSize: 16,
    fontWeight: 500,
  },
  Body10pxHeavy: {
    fontSize: 10,
    fontWeight: 700,
  },
  Body12pxRegular: {
    fontSize: 12,
    fontWeight: 400,
  },
  Body12pxMedium: {
    fontSize: 12,
    fontWeight: 500,
  },
  Body12pxHeavy: {
    fontSize: 12,
    fontWeight: 700,
  },
  Body14pxRegular: {
    fontSize: 14,
    fontWeight: 400,
  },
  Body14pxMedium: {
    fontSize: 14,
    fontWeight: 500,
  },
  Body14pxHeavy: {
    fontSize: 14,
    fontWeight: 700,
  },
  Body16pxRegular: {
    fontSize: 16,
    fontWeight: 400,
  },
  Body16pxMedium: {
    fontSize: 16,
    fontWeight: 500,
  },
  Body16pxHeavy: {
    fontSize: 16,
    fontWeight: 700,
  },
  Body18pxRegular: {
    fontSize: 18,
    fontWeight: 400,
  },
  Body18pxMedium: {
    fontSize: 18,
    fontWeight: 500,
  },
  H4Semibold: {
    fontSize: 31,
    fontWeight: 600,
  },
  H5Semibold: {
    fontSize: 25,
    fontWeight: 600,
  },
  H5Medium: {
    fontSize: 25,
    fontWeight: 500,
  },
  H5Regular: {
    fontSize: 25,
    fontWeight: 400,
  },
  H6Medium: {
    fontSize: 20,
    fontWeight: 500,
  },
  H6Regular: {
    fontSize: 18,
    fontWeight: 400,
  },
  H6Semibold: {
    fontSize: 18,
    fontWeight: 600,
  },
  HeaderSubtitleXSmallRegular: {
    fontSize: 10,
    fontWeight: 400,
  },
  HeaderSubtitleSmallRegular: {
    fontSize: 12,
    fontWeight: 400,
  },
  HeaderSubtitleSmallMedium: {
    fontSize: 12,
    fontWeight: 500,
  },
  HeaderSubtitleSmallSemibold: {
    fontSize: 12,
    fontWeight: 600,
  },
  HeaderSubtitleMediumMedium: {
    fontSize: 14,
    fontWeight: 500,
  },
  HeaderSubtitleMediumRegular: {
    fontSize: 14,
    fontWeight: 400,
  },
  HeaderSubtitleMediumLight: {
    fontSize: 14,
    fontWeight: 300,
  },
  HeaderSubtitleMediumBold: {
    fontSize: 14,
    fontWeight: 700,
  },
  HeaderSubtitleMediumSemibold: {
    fontSize: 14,
    fontWeight: 600,
  },
  HeaderSubtitleLargeRegular: {
    fontSize: 16,
    fontWeight: 400,
  },
  HeaderSubtitleLargeMedium: {
    fontSize: 16,
    fontWeight: 500,
  },
  HeaderSubtitleLargeSemibold: {
    fontSize: 16,
    fontWeight: 600,
  },
  HelperText: {
    fontSize: 12,
    fontWeight: 400,
  },
  Tooltip: {
    fontSize: 10,
    fontWeight: 400,
  },
  Tagline: {
    fontSize: 36,
    fontWeight: 600,
    lineHeight: '43px',
    fontFamily: 'var(--font-source_sans_3)',
  },
  fontFamily: DEFAULT_FONT_FAMILY,
}
